import { WeighmentSitesAPI } from "api";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchCustomers } from "../../../../hooks/useFetchCustomer";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const maxCharactersLength = 255;

  const { data: customersData, isLoading: customerLoading } =
    useFetchCustomers();

  // console.log("customersData", customersData?.data?.data);

  return (
    <>
      {loading || customerLoading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Coupon Code"
                  className="py-2 mb-1"
                  {...register("code")}
                  isInvalid={!!errors.code}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.code?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  className="py-2 mb-1"
                  {...register("name")}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  {...register("discountType")}
                  className="py-2 mb-1"
                  isInvalid={!!errors.discountType}
                >
                  <option value="">Select Discount Type</option>
                  <option value="Percent">Percent</option>
                  <option value="Fixed">Fixed</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.discountType?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="number"
                  placeholder="Value"
                  className="py-2 mb-1"
                  {...register("value")}
                  isInvalid={!!errors.value}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.value?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Valid From"
                  className="py-2 mb-1"
                  {...register("validFrom")}
                  isInvalid={!!errors.validFrom}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.validFrom?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Valid To"
                  className="py-2 mb-1"
                  {...register("validTo")}
                  isInvalid={!!errors.validTo}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.validTo?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  {...register("customerId")}
                  className="py-2 mb-1"
                  isInvalid={!!errors.customerId}
                >
                  <option value="">Select Customer</option>
                  {customersData?.data?.data?.map((customer) => (
                    <option key={customer.id} value={Number(customer.id)}>
                      {customer.firstName} {customer.lastName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.customerId?.message}
                </Form.Control.Feedback>
              </Form.Group>

              {/* <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Customer"
                  className="py-2 mb-1"
                  {...register("customer")}
                  isInvalid={!!errors.customer}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.customer?.message}
                </Form.Control.Feedback>
              </Form.Group> */}
            </Col>

            <Col md="6">
              <Form.Select
                {...register("productId")}
                className="py-2 mb-1"
                isInvalid={!!errors.productId}
              >
                <option value="">Select Product</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.productId?.message}
              </Form.Control.Feedback>

              {/* <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Product"
                  className="py-2 mb-1"
                  {...register("product")}
                  isInvalid={!!errors.product}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.product?.message}
                </Form.Control.Feedback>
              </Form.Group> */}
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="number"
                  placeholder="Usage Limit"
                  className="py-2 mb-1"
                  {...register("usageLimit")}
                  isInvalid={!!errors.usageLimit}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.usageLimit?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="number"
                  placeholder="Used Count"
                  className="py-2 mb-1"
                  {...register("usedCount")}
                  isInvalid={!!errors.usedCount}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.usedCount?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
